export enum ErrorCodeEnum {
  'VALIDATION_FAILED' = 'VALIDATION_FAILED',
}
